import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, CircularProgress } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { BsDatabaseFill } from "react-icons/bs";

import BubbleChart from "../../../components/charts/BubbleChart";

const BubbleChartSection = ({ title, subtitle }) => {
  const { t } = useTranslation();
  const { sales, loading_sales } = useSelector(
    (state) => state.financial_insights.financial_insights
  );

  // const company_grade = companies?.avg_grade?.toFixed(1);
  return (
    <div className="h-full flex flex-col">
      <div className="w-full 2xl:max-w-[480px] h-auto flex justify-between mb-4">
        <div className="flex flex-col">
          <h1 className="text-[14px] text-primary font-semibold">{t(title)}</h1>
          <div className="flex items-center w-full space-x-2">
            <span className="text-xs text-gray-400 whitespace-nowrap">{t(subtitle)}</span>
          </div>
        </div>
      </div>
      <div className="flex-1 w-full grow">
        {loading_sales && (
          <div className="flex flex-col justify-center items-center w-auto h-96 m-auto text-sm">
            <CircularProgress
              aria-label="Loading..."
              color="primary"
              label="Loading..."
            />
          </div>
        )}
        {!loading_sales && sales && sales.length > 0 ? (
          <BubbleChart data={sales} />
        ) : !loading_sales ? (
          <div className="w-full h-full flex-1 flex flex-col items-center justify-center">
            <BsDatabaseFill className="text-gray-300 w-12 h-12" />
            <h3 className="text-sm text-gray-400 mt-3">{t("No records to display")}</h3>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default BubbleChartSection;
